import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export default function PushNotificationLog() {


    const navigate = useNavigate();

    const [rows, setRows] = useState([]);
    const [meta, setMeta] = useState({ total: 0, page: 1, limit: 20, totalPages: 1 });

    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState("");

    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const fetchNotificationLogs = async (opts = {}) => {
    const nextPage = opts.page ?? page;
    const nextLimit = opts.limit ?? limit;

        setLoading(true);
        setErr("");

        try {
            const res = await api.get("/admin/push-notification-logs", {
                params: { search: search || undefined, page: nextPage, limit: nextLimit, sortBy: "created_at", order: "DESC", },
            });
            console.log(res.data?.data);
            setRows(res.data?.data || []);
            setMeta(res.data?.meta || { total: 0, page: nextPage, limit: nextLimit, totalPages: 1 });
            
        } catch (e) {
        const msg = e?.response?.data?.message || e.message || "Failed to load logs";
            setErr(msg);
        toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNotificationLogs({ page: 1 });
    }, []);

    const onApply = (e) => {
        e.preventDefault();
        setPage(1);
        fetchNotificationLogs({ page: 1 });
    };


        const goPrev = () => {
        if (meta.page <= 1) return;
        const p = meta.page - 1;
        setPage(p);
        fetchNotificationLogs({ page: p });
    };

    const goNext = () => {
        if (meta.page >= meta.totalPages) return;
        const p = meta.page + 1;
        setPage(p);
        fetchNotificationLogs({ page: p });
    };

    const onLimitChange = (e) => {
        const v = Number(e.target.value) || 10;
        setLimit(v);
        setPage(1);
        fetchNotificationLogs({ page: 1, limit: v });
    };

    const getUserName = (row) => {
        if (row.user) {
            const first = row.user.first_name || "";
            const last = row.user.last_name || "";
            return `${first} ${last}`.trim() || "N/A";
        }
        const first = row.first_name || "";
        const last = row.last_name || "";
        return `${first} ${last}`.trim() || "N/A";
    };

    const formatNotificationType = (type) => {
        if (!type) return "N/A";
        return type.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()); 
    };

    return (
        <div>
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
            <div>
            <h1 className="text-2xl font-bold">Notification Logs</h1>
            </div>

        </div>

        <form onSubmit={onApply} className="mt-6 flex flex-col sm:flex-wrap sm:flex-row items-stretch sm:items-end gap-3 border rounded-2xl p-4">
            <div className="w-full sm:w-auto sm:min-w-[240px]">
            <label className="text-sm font-semibold">Search</label>
            <input
                className="mt-2 w-full border rounded-xl px-3 py-2 outline-none focus:ring-2 focus:ring-black"
                placeholder="Search by title..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />
            </div>

            <div className="w-full sm:w-auto sm:min-w-[200px]">
            <label className="text-sm font-semibold">Status</label>
            <select
                className="mt-2 w-full border rounded-xl px-3 py-2 outline-none focus:ring-2 focus:ring-black"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
            >
                <option value="">All</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
            </select>
            </div>

            <div className="w-full sm:w-auto sm:min-w-[140px]">
            <label className="text-sm font-semibold">Per page</label>
            <select
                className="mt-2 w-full border rounded-xl px-3 py-2 outline-none focus:ring-2 focus:ring-black"
                value={limit}
                onChange={onLimitChange}
            >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
            </select>
            </div>

            <button
            type="submit"
            className="w-full sm:w-auto rounded-xl bg-black px-4 py-2 text-white text-sm font-semibold hover:opacity-90"
            >
            Apply
            </button>
        </form>

        {err ? <div className="mt-4 text-sm text-red-600">{err}</div> : null}

        <div className="mt-6 border rounded-2xl overflow-hidden">
            <div className="bg-gray-50 px-4 py-3 text-sm font-semibold flex flex-col sm:flex-row sm:items-center justify-between gap-2">
            <span>Notification Log List</span>

            <div className="flex flex-wrap items-center gap-2 text-sm">
                <button
                onClick={goPrev}
                disabled={meta.page <= 1 || loading}
                className="rounded-lg border px-3 py-1 font-semibold disabled:opacity-50"
                type="button"
                >
                Prev
                </button>

                <span className="text-gray-700">
                Page <b>{meta.page}</b> / <b>{meta.totalPages}</b> (Total: <b>{meta.total}</b>)
                </span>

                <button
                onClick={goNext}
                disabled={meta.page >= meta.totalPages || loading}
                className="rounded-lg border px-3 py-1 font-semibold disabled:opacity-50"
                type="button"
                >
                Next
                </button>
            </div>
            </div>

            {loading ? (
            <div className="p-4 text-sm text-gray-600">Loading...</div>
            ) : rows.length === 0 ? (
            <div className="p-4 text-sm text-gray-600">No Logs found.</div>
            ) : (
            <div className="overflow-x-auto">
            <table className="w-full text-sm">
                <thead className="border-t bg-white">
                <tr className="text-left">
                    {/* <th className="px-4 py-3">User ID</th> */}
                    <th className="px-4 py-3">User</th>
                    <th className="px-4 py-3">Title</th>
                    <th className="px-4 py-3">Content</th>
                    <th className="px-4 py-3">Type</th>
                    <th className="px-4 py-3">Provider</th>
                    <th className="px-4 py-3">Channel</th>
                    <th className="px-4 py-3">Delivery Status</th>
                </tr>
                </thead>

                <tbody className="border-t">
                {rows.map((p) => (
                    <tr key={p.push_notification_log_id} className="border-t hover:bg-gray-50">
                    {/* <td className="px-4 py-3 font-semibold">{p.user_id}</td> */}
                    <td className="px-4 py-3 font-medium text-gray-800"> {getUserName(p)} </td>
                    <td className="px-4 py-3 font-semibold">{p.title}</td>
                    <td className="px-4 py-3"> {p.body} </td>
                    <td className="px-4 py-3">{formatNotificationType(p.notification_type)}</td>
                    <td className="px-4 py-3">{p.provider}</td>
                    <td className="px-4 py-3">{p.channel}</td>
                    <td className="px-4 py-3">{p.delivery_status}</td>
                    </tr>
                ))}
                </tbody>
            </table>
            </div>
            )}
        </div>
        </div>
    );

}